import { TeacherResourceType } from 'backend/services/types/urApiService.enums'
import { FilterProp } from 'frontend/types'
import { filterTeacherResourceClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import { activeOptionLabel } from 'frontend/utils/helpers'
import FilterDropdown from './FilterDropdown/FilterDropdown'
import { SearchParams } from 'backend/services/types/urApiService.types'

type Props = {
  teacherResources: FilterProp[]
  searchParams: SearchParams
  updateSearch: (params: SearchParams) => void
}

const TeacherResources = ({
  teacherResources,
  searchParams,
  updateSearch,
}: Props) => {
  const { teacher_resource_type: teacherResourceType } = searchParams

  const activeLabels = activeOptionLabel(
    [...teacherResources],
    teacherResourceType || '',
    true,
  )

  const handleOptionSelect = (option: FilterProp) => {
    const isSelected = activeLabels.includes(option.label)

    if (!isSelected) filterTeacherResourceClick(option.label)

    updateSearch({
      teacher_resource_type: option.value as TeacherResourceType,
    })
  }

  return (
    <FilterDropdown
      activeLabels={activeLabels}
      label="Pedagogiskt material"
      onOptionSelect={handleOptionSelect}
      options={teacherResources}
    />
  )
}

export default TeacherResources
